import { render, staticRenderFns } from "./MCategoryList.vue?vue&type=template&id=7108a9e7&"
import script from "./MCategoryList.vue?vue&type=script&lang=js&"
export * from "./MCategoryList.vue?vue&type=script&lang=js&"
import style0 from "./MCategoryList.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports